import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import Business from '../components/Setting/BusinessConfiguration'
import { makeStyles, Grid, Tabs, Tab, Box } from '@material-ui/core'
import BusinessConfig1 from '../../src/components/Setting/BusinessConfig1'
import BusinessConfig2 from '../../src/components/Setting/BusinessConfig2'
import BusinessConfig3 from '../../src/components/Setting/BusinessConfig3'
// import ProfilePic from '../../src/assets/images/Profile.PNG'
import { useCompanyConfig } from '../hooks/CompanyConfiguration/useCompanyConfig'
import ThreetabsLayout from '../components/ThreetabsLayout'
import ActionButton from '../components/ActionButton'
import PersonalInformation from '../components/Setting/PersonalInformation'
import Notifications from '../components/Setting/Notifications'
import Loader from '../components/Loader'
import { isArray, uploadFilesToAws } from '../shared/constants'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F5F8FF',
    borderRadius: '10px',

    // margin: '10px 30px 10px 0px',
  },
  tab: {
    textTransform: 'none',
    fontFamily: 'Open sans',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '20px',
  },
  tabs: {
    '& > span': {
      maxWidth: '50px',
      width: '100%',
    },
    input: {
      '&:focus': {
        outline: 'none',
      },
    },
  },
}))

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}
function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  )
}

export const BusinessConfiguration = () => {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)
  // const [leavingTime, setLeavingTime] = React.useState(0)
  // const [reportingTime, setReportingTime] = React.useState(0)
  const { loggedUser, getLoggedInUser, updateCompanyConfig, updateCompanyPersonalInfo, updateCompanyAccount } = useCompanyConfig()

  const [basicInfoForm, setBasicInfoForm] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    phone: '',
    email: '',
    numberofemployees: '',
    domain: '',
    profilePicture: '',
    companyId: '',
    website: '',
  })

  const [accountSetting, setAccountSetting] = useState({
    language: '',
    currency: '',
    timeZone: '',
    financialYear: '',
    reportingTime: '',
    leavingTime: '',
    workingDaysFrom: '',
    workingDaysTo: '',
    holidayFrom: '',
    holidayTo: '',
    leadDiscount: 0,
    incentiveYears: 0,
    quoteDisclaimer: '',
    radius: '',
    graceTimePeriod: '',
    splashScreen: '',
    leadValidityNotification: '',
  })
  const [privacyDetails, setPrivacyDetails] = useState({
    question1: null,
    question2: null,
    question3: null,
    question4: null,
  })
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  //console.log('Account settings:', accountSetting)
  useEffect(() => {
    getLoggedInUser()
  }, [])

  useEffect(() => {
    if (loggedUser) {
      setBasicInfoForm({
        ...basicInfoForm,
        firstName: loggedUser.firstName,
        companyId: loggedUser.companyId,
        lastName: loggedUser.lastName,
        companyName: loggedUser.name,
        phone: loggedUser.phoneNumber,
        email: loggedUser.email,
        numberofemployees: loggedUser.employeeCount,
        domain: loggedUser.domain,
        profilePicture: loggedUser.profilePicture,
        gst: loggedUser.gst,
        website: loggedUser.website,
      })
      setAccountSetting({
        ...accountSetting,
        language: loggedUser.language,
        currency: loggedUser.currency,
        timeZone: loggedUser.timeZone,
        financialYear: loggedUser.financialYear,
        workingDaysFrom: loggedUser.workingDaysFrom,
        workingDaysTo: loggedUser.workingDaysTo,
        holidayFrom: loggedUser.holidayFrom,
        holidayTo: loggedUser.holidayTo,
        leadDiscount: loggedUser.leadDiscount,
        incentiveYears: loggedUser.incentiveYears,
        quoteDisclaimer: loggedUser.quoteDisclaimer,
        radius: loggedUser.radius,
        reportingTime: loggedUser.reportingTime,
        leavingTime: loggedUser.leavingTime,
        graceTimePeriod: loggedUser.graceTimePeriod,
        splashScreen: [loggedUser.splashScreen],
        leadValidityNotification: loggedUser.leadValidityNotification,
      })
      // setReportingTime(loggedUser.reportingTime)
      // setLeavingTime(loggedUser.leavingTime)

      // setPrivacyDetails({
      //  ...privacyDetails,

      // })
    }
  }, [loggedUser])

  const updateCompanyPage = () => {
    updateCompanyConfig({
      phoneNumber: basicInfoForm.phone,
      name: basicInfoForm.companyName,
      employeeCount: basicInfoForm.numberofemployees,
      email: basicInfoForm.email,
      domain: basicInfoForm.domain,
      profilePicture: basicInfoForm.profilePicture,
      gst: basicInfoForm.gst,
      companyId: basicInfoForm.companyId,
      website: basicInfoForm.website,
    })
  }

  const updateCompanyPersonal = () => {
    updateCompanyPersonalInfo({
      firstName: basicInfoForm.firstName,
      lastName: basicInfoForm.lastName,
    })
  }

  const updateCompanyAccountSetting = async () => {
    let location = accountSetting.splashScreen
    if (!isArray(accountSetting.splashScreen)) {
      location = await uploadFilesToAws(accountSetting.splashScreen)
    }

    updateCompanyAccount({
      language: accountSetting.language,
      currency: accountSetting.currency,
      timeZone: accountSetting.timeZone,
      financialYear: accountSetting.financialYear,
      reportingTime: accountSetting.reportingTime,
      leavingTime: accountSetting.leavingTime,
      workingDaysFrom: accountSetting.workingDaysFrom,
      workingDaysTo: accountSetting.workingDaysTo,
      holidayFrom: accountSetting.holidayFrom,
      holidayTo: accountSetting.holidayTo,
      leadDiscount: accountSetting.leadDiscount,
      incentiveYears: accountSetting.incentiveYears,
      quoteDisclaimer: accountSetting.quoteDisclaimer,
      radius: accountSetting.radius,
      splashScreen: location[0],
      graceTimePeriod: accountSetting.graceTimePeriod,
      leadValidityNotification: accountSetting.leadValidityNotification,
    })
  }

  return (
    <Layout heading="Business Configuration" none>
      <div style={{ padding: '0px 20px 20px 20px' }}>
        <Grid container className={classes.root}>
          <Grid item xs={12} lg={12}>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" className={classes.tabs}>
              <Tab
                label="Company Information"
                {...a11yProps(0)}
                className={classes.tab}
                // disabled={value === 1 || value === 2 ? true : false}
              />
              <Tab
                label="Personal Information"
                {...a11yProps(0)}
                className={classes.tab}
                // disabled={value === 1 || value === 2 ? true : false}
              />
              <Tab
                label="Account Settings"
                {...a11yProps(1)}
                className={classes.tab}
                // disabled={!added || value === 2 ? true : false}
              />
              <Tab
                label="Access Role"
                {...a11yProps(2)}
                className={classes.tab}
                // disabled={!added && !addedLocation ? true : false}
              />
              <Tab
                label="Notifications"
                {...a11yProps(2)}
                className={classes.tab}
                // disabled={!added && !addedLocation ? true : false}
              />
            </Tabs>
          </Grid>

          <Grid item xs={12} lg={12}>
            <TabPanel value={value} index={0}>
              {loggedUser ? <BusinessConfig1 form={basicInfoForm} setForm={setBasicInfoForm} /> : <Loader />}
            </TabPanel>
          </Grid>

          <Grid item xs={12} lg={12}>
            <TabPanel value={value} index={1}>
              <div>
                <PersonalInformation form={basicInfoForm} setForm={setBasicInfoForm} />
              </div>
            </TabPanel>
          </Grid>

          <TabPanel value={value} index={2}>
            <BusinessConfig2 form={accountSetting} setForm={setAccountSetting} />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <BusinessConfig3 form={privacyDetails} setForm={setPrivacyDetails} />
          </TabPanel>
          <Grid item xs={12} lg={8}>
            <TabPanel value={value} index={4}>
              <Notifications />
            </TabPanel>
          </Grid>

          {/* <ActionButton handleSubmit={value === 0 ? handleAddEmployee : value === 1 ? handleAddLocation : handleAddKyc} /> */}
          <Grid item lg={12} style={{ paddingLeft: '20px' }}>
            <ActionButton handleSubmit={value === 0 ? updateCompanyPage : value === 1 ? updateCompanyPersonal : value === 2 ? updateCompanyAccountSetting : null} />
          </Grid>
        </Grid>
      </div>
    </Layout>
  )
}
